import { makeStyles } from 'tss-react/mui';
import { default as _omit } from 'lodash-es/omit';
import { inputStyles } from '../../styles/jss/inputs';
import { colors, spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme, _params, classes) => {
    const base = _omit(inputStyles(theme, classes), 'textContainer');
    return Object.assign(Object.assign({ hasPopupIcon: {
            display: 'none',
        }, root: {
            width: '100%',
        }, popper: {
            display: 'none',
        }, popperOpen: {
            display: 'block',
            zIndex: _params.isFromPCCBanner ? 1300 : 5,
        }, outsideDOM: {
            '& .MuiAutocomplete-listbox': {
                maxHeight: _params.height || '40vh',
            },
        }, paper: {
            left: '-9px',
            position: 'relative',
            width: 'calc(100% + 18px)',
            border: `1px solid ${colors.supplementary.black}`,
            boxShadow: '0px 0px 8px #008BE9, 0px 4px 8px rgba(0, 0, 0, 0.32)',
            '& .MuiAutocomplete-noOptions': {
                display: 'none',
            },
            '& .MuiAutocomplete-loading': {
                display: 'none',
            },
        }, option: Object.assign(Object.assign({ cursor: 'pointer' }, theme.typography.small_regular), { lineHeight: '2.5rem', borderBottom: `1px solid ${colors.grey.grey2}`, '&:last-child': {
                borderBottom: 'none',
            }, padding: `0px ${spacing.xs}`, '&:hover': {
                backgroundColor: colors.grey.grey1,
            }, '&.Mui-focused': {
                backgroundColor: colors.grey.grey1,
            } }), manualAddress: {
            padding: `${spacing.small} ${spacing.xs}`,
            zIndex: _params.isFromPCCBanner ? 1300 : 1,
        }, resultsShown: {
            borderTop: `1px solid ${colors.supplementary.black}`,
        }, manualEntryButton: {
            color: theme.isFlyingFlowers ? colors.black[700] : colors.primary.gold5,
            textDecoration: 'underline',
            cursor: 'pointer',
            '&:hover': {
                color: theme.isFlyingFlowers ? colors.wildExotic[500] : undefined,
            },
        }, textContainer: {
            [`& .${classes.manualAddress}`]: {
                padding: `${spacing.small} ${spacing.xs} ${spacing.xs} ${spacing.xs}`,
                margin: '0 -8px 0 -8px',
            },
            '& .MuiAutocomplete-input': {
                margin: 0,
                padding: '0!important',
            },
            '& .MuiCircularProgress-root': {
                position: 'relative',
                top: '0px',
                left: '0px',
            },
        } }, _omit(inputStyles(theme, classes), 'textContainer')), { success: Object.assign(Object.assign({}, base.success), { [`&:hover .${classes.successAdornmentIcon}`]: { display: 'none' } }), successAdornmentWrapper: {
            position: 'relative',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '1.5rem',
            minHeight: '1.5rem',
            '& .MuiAutocomplete-endAdornment': {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                right: 'unset',
                bottom: 'unset',
            },
        }, successAdornmentIcon: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: theme.statusColors.success.base,
            fontSize: '1.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'none',
            zIndex: 1,
        }, recipientAddressLabel: Object.assign(Object.assign(Object.assign({}, theme.typography.small_bold), theme.typographySpacing.small_bold_lg), { color: colors.black[700] }), pccBannerModal: {
            '& .MuiBackdrop-root': {
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
            },
            '& .MuiPaper-root': {
                width: '100%',
                maxHeight: '100%',
                padding: 0,
                borderRadius: 0,
                border: `1px solid ${colors.supplementary.black}`,
                backgroundColor: colors.grey.grey1,
                boxShadow: 'none',
                maxWidth: '1336px',
                [theme.breakpoints.up('md')]: {
                    width: `calc(100% - ${spacing.xxl})`,
                    maxHeight: '90vh',
                },
            },
            'div#bodyContainer': {
                marginTop: '-72px',
                padding: `0 20px 70px !important`,
                [theme.breakpoints.up('md')]: {
                    padding: `0 ${spacing.large} 96px !important`,
                },
                h3: Object.assign(Object.assign({ margin: 0 }, theme.typography.medium_regular), { color: colors.grey.grey6, width: '100 %', paddingBottom: '27px', [theme.breakpoints.up('sm')]: {
                        margin: '0 auto',
                        maxWidth: '520px',
                    } }),
            },
            '& header': {
                marginBottom: `${spacing.medium} !important`,
                padding: `${spacing.small} 20px 0 20px`,
                [theme.breakpoints.up('md')]: {
                    padding: `${spacing.large} ${spacing.large} 0 ${spacing.large}`,
                },
                '& .MuiFab-root': {
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.24)',
                },
            },
            '& .MuiDialogContent-root': {
                padding: `0 20px 20px`,
                [theme.breakpoints.up('md')]: {
                    padding: `0 ${spacing.large} ${spacing.large}`,
                },
                '& > div': {
                    margin: 0,
                    width: '100%',
                    [theme.breakpoints.up('sm')]: {
                        margin: '0 auto',
                        maxWidth: '520px',
                    },
                },
            },
        } });
});
export default useStyles;
